<template>
    <el-form v-if="show" :model="vo" @submit.native.prevent>
        <div style="width: 100%" class="el-table el-table--fit el-table--border">
            <div class="el-table__body-wrapper">
                <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                    <tbody>
                        <tr>
                            <td ref="tdlbl_姓名" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'name'" class="field">姓名</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="name"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入姓名',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '姓名',
                                        propName: 'name',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 5,
                                        valueMinLength: null,
                                        model: 'vo.name',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 1,
                                        showWordLimit: false,
                                        dialogMultiple: false,
                                        dialogType: 'staff',
                                        dialogOrgLevel: '',
                                        dialogSelectedOrderBy: 'orgOrderNo',
                                        dialogOrgSelf: false,
                                        dialogOnlyCurSys: true
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_身份证号" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'idCardNumber'" class="field">身份证号</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="idCardNumber"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '',
                                        errorMessage: null,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '身份证号',
                                        propName: 'idCardNumber',
                                        propType: 'String',
                                        textFormatter: 'card',
                                        valueMaxLength: 100,
                                        valueMinLength: null,
                                        tbFieldName: 'idcardnumber',
                                        iconName: 'shenfenzheng',
                                        model: 'vo.idCardNumber',
                                        option: [],
                                        formTdAlign: 'text-left',
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_性别" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'sex'" class="field">性别</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <template v-if="canEdit">
                                    <form-item
                                        ref="sex"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '0：女\n1：男',
                                            elementReadonly: 1,
                                            elementType: 'radio',
                                            emptyMessage: '请选择性别',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '性别',
                                            propName: 'sex',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.sex',
                                            option: [
                                                { value: '0', name: '女' },
                                                { value: '1', name: '男' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: false,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </template>
                                <template v-else>{{ vo.sex == 0 ? '女' : '男' }}</template>
                            </td>
                            <!-- <td ref="tdlbl_证件照片" class="el-table__cell tdlbl tdw13" colspan="1">

                                <span v-field-lbl="'idPhoto'" class="field">证件照片</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <el-upload
v-if="canEdit===1" ref="upload" class="upload"
                                    :on-change="handleUploadChange" action="" :show-file-list="false"
                                    :auto-upload="false" :with-credentials="true" :accept="'.jpg,.png'"
>
                                    <el-input v-model="vo.idPhoto" readonly name="idPhoto" placeholder="请上传照片">
                                        <el-button slot="append" icon="el-icon-upload2" />
                                    </el-input>
                                </el-upload>
                                <div v-if="viewFile" style="display: flex;justify-content: center;align-items: center;">
                                    <img style="max-width:98%;max-height:100px;" :src="imageSrc">
                                </div>
                            </td> -->
                        </tr>
                        <tr>
                            <td ref="tdlbl_出生日期" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'birthday'" class="field">出生日期</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="birthday"
                                    :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: '', elementReadonly: 1, elementType: 'date', emptyMessage: '', errorMessage: null, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '出生日期', propName: 'birthday', propType: 'java.util.Date', textFormatter: 'yyyy-MM-dd', valueMaxLength: null, valueMinLength: null, tbFieldName: 'birthday', iconName: 'sjxzk', model: 'vo.birthday', option: [], formTdAlign: 'text-left', formTdColspan: 8, weekday: 0 }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_年龄" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'age'" class="field">年龄</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="age"
                                    :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '', errorMessage: null, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '年龄', propName: 'age', propType: 'String', textFormatter: 'integer', valueMaxLength: 2, valueMinLength: null, tbFieldName: 'age', iconName: 'zhengshu', model: 'vo.age', option: [], formTdAlign: 'text-left', formTdColspan: 8, autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_籍贯" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'nativePlace'" class="field">籍贯</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="nativePlace"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '北京：北京\n天津：天津\n河北：河北\n山西：山西\n内蒙古：内蒙古\n辽宁：辽宁\n吉林：吉林\n黑龙江：黑龙江\n上海：上海\n江苏：江苏\n浙江：浙江\n安徽：安徽\n福建：福建\n江西：江西\n山东：山东\n河南：河南\n湖北：湖北\n湖南：湖南\n广东：广东\n广西：广西\n海南：海南\n重庆：重庆\n四川：四川\n贵州：贵州\n云南：云南\n西藏：西藏\n陕西：陕西\n甘肃：甘肃\n青海：青海\n宁夏：宁夏\n新疆：新疆\n台湾：台湾\n香港：香港\n澳门：澳门',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '请选择籍贯',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '籍贯',
                                        propName: 'nativePlace',
                                        propType: 'Short',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.nativePlace',
                                        option: [
                                            { name: '北京', value: '北京' },
                                            { name: '天津', value: '天津' },
                                            { name: '河北', value: '河北' },
                                            { name: '山西', value: '山西' },
                                            { name: '内蒙', value: '内蒙古' },
                                            { name: '辽宁', value: '辽宁' },
                                            { name: '吉林', value: '吉林' },
                                            { name: '黑龙', value: '黑龙江' },
                                            { name: '上海', value: '上海' },
                                            { name: '江苏', value: '江苏' },
                                            { name: '浙江', value: '浙江' },
                                            { name: '安徽', value: '安徽' },
                                            { name: '福建', value: '福建' },
                                            { name: '江西', value: '江西' },
                                            { name: '山东', value: '山东' },
                                            { name: '河南', value: '河南' },
                                            { name: '湖北', value: '湖北' },
                                            { name: '湖南', value: '湖南' },
                                            { name: '广东', value: '广东' },
                                            { name: '广西', value: '广西' },
                                            { name: '海南', value: '海南' },
                                            { name: '重庆', value: '重庆' },
                                            { name: '四川', value: '四川' },
                                            { name: '贵州', value: '贵州' },
                                            { name: '云南', value: '云南' },
                                            { name: '西藏', value: '西藏' },
                                            { name: '陕西', value: '陕西' },
                                            { name: '甘肃', value: '甘肃' },
                                            { name: '青海', value: '青海' },
                                            { name: '宁夏', value: '宁夏' },
                                            { name: '新疆', value: '新疆' },
                                            { name: '台湾', value: '台湾' },
                                            { name: '香港', value: '香港' },
                                            { name: '澳门', value: '澳门' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td ref="tdlbl_婚姻情况" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'marriage'" class="field">婚姻情况</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="marriage"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：未婚\n1：已婚\n2：离异\n3：丧偶',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '请选择婚姻情况',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '婚姻情况',
                                        propName: 'marriage',
                                        propType: 'Short',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.marriage',
                                        option: [
                                            { value: '0', name: '未婚' },
                                            { value: '1', name: '已婚' },
                                            { value: '2', name: '离异' },
                                            { value: '3', name: '丧偶' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_政治面貌" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'politicalOutlook'" class="field">政治面貌</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="politicalOutlook"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：中共党员\n1：中共预备党员\n2：共青团员\n3：民革会员\n4：民盟盟员\n5：民建会员\n6：民进会员\n7：农工党党员\n8：致公党党员\n9：九三学社社员\n10：台盟盟员\n11：无党派民主人士\n12：群众',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '请选择政治面貌',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '政治面貌',
                                        propName: 'politicalOutlook',
                                        propType: 'Short',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.politicalOutlook',
                                        option: [
                                            { value: '0', name: '中共党员' },
                                            { value: '1', name: '中共预备党员' },
                                            { value: '2', name: '共青团员' },
                                            { value: '3', name: '民革会员' },
                                            { value: '4', name: '民盟盟员' },
                                            { value: '5', name: '民建会员' },
                                            { value: '6', name: '民进会员' },
                                            { value: '7', name: '农工党党员' },
                                            { value: '8', name: '致公党党员' },
                                            { value: '9', name: '九三学社社员' },
                                            { value: '10', name: '台盟盟员' },
                                            { value: '11', name: '无党派民主人士' },
                                            { value: '12', name: '群众' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_人才标识" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'talentMark'" class="field">人才标识</span>
                            </td>
                            <td class="el-table__cell tdcont" colspan="1">
                                <form-item
                                    ref="talentMark"
                                    :field="{
                                        defaultValue: '无',
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '人才骨干：人才骨干\n青年干部：青年干部',
                                        elementReadonly: 0,
                                        elementType: 'select',
                                        emptyMessage: '请选择人才标识',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 8,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '人才标识',
                                        propName: 'talentMark',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 20,
                                        valueMinLength: null,
                                        model: 'vo.talentMark',
                                        option: [
                                            { name: '无', value: '无' },
                                            { name: '人才骨干', value: '人才骨干' },
                                            { name: '青年干部', value: '青年干部' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false,
                                        readonlyShowChecked: 0
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td ref="tdlbl_民族" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'nation'" class="field">民族</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="nation"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter:
                                            '汉族：汉族\n满族：满族\n蒙古族：蒙古族\n回族：回族\n藏族：藏族\n维吾尔族：维吾尔族\n苗族：苗族\n彝族：彝族\n壮族：壮族\n布依族：布依族\n侗族：侗族\n瑶族：瑶族\n白族：白族\n土家族：土家族\n哈尼族：哈尼族\n哈萨克族：哈萨克族\n傣族：傣族\n黎族：黎族\n傈僳族：傈僳族\n佤族：佤族\n畲族：畲族\n高山族：高山族\n拉祜族：拉祜族\n水族：水族\n东乡族：东乡族\n纳西族：纳西族\n景颇族：景颇族\n赫哲族：赫哲族\n柯尔克孜族：柯尔克孜族\n土族：土族\n达斡尔族：达斡尔族\n仫佬族：仫佬族\n羌族：羌族\n布朗族：布朗族\n撒拉族：撒拉族\n毛南族：毛南族\n仡佬族：仡佬族\n锡伯族：锡伯族\n阿昌族：阿昌族\n普米族：普米族\n朝鲜族：朝鲜族\n塔吉克族：塔吉克族\n怒族：怒族\n乌孜别克族：乌孜别克族\n俄罗斯族：俄罗斯族\n鄂温克族：鄂温克族\n德昂族：德昂族\n保安族：保安族\n裕固族：裕固族\n京族：京族\n塔塔尔族：塔塔尔族\n独龙族：独龙族\n鄂伦春族：鄂伦春族\n门巴族：门巴族\n珞巴族：珞巴族\n基诺族：基诺族',
                                        elementReadonly: 0,
                                        elementType: 'select',
                                        emptyMessage: '请输入民族',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 8,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '民族',
                                        propName: 'nation',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 30,
                                        valueMinLength: null,
                                        model: 'vo.nation',
                                        option: [
                                            { value: '汉族', name: '汉族' },
                                            { value: '满族', name: '满族' },
                                            { value: '蒙古族', name: '蒙古族' },
                                            { value: '回族', name: '回族' },
                                            { value: '藏族', name: '藏族' },
                                            { value: '维吾尔族', name: '维吾尔族' },
                                            { value: '苗族', name: '苗族' },
                                            { value: '彝族', name: '彝族' },
                                            { value: '壮族', name: '壮族' },
                                            { value: '布依族', name: '布依族' },
                                            { value: '侗族', name: '侗族' },
                                            { value: '瑶族', name: '瑶族' },
                                            { value: '白族', name: '白族' },
                                            { value: '土家族', name: '土家族' },
                                            { value: '哈尼族', name: '哈尼族' },
                                            { value: '哈萨克族', name: '哈萨克族' },
                                            { value: '傣族', name: '傣族' },
                                            { value: '黎族', name: '黎族' },
                                            { value: '傈僳族', name: '傈僳族' },
                                            { value: '佤族', name: '佤族' },
                                            { value: '畲族', name: '畲族' },
                                            { value: '高山族', name: '高山族' },
                                            { value: '拉祜族', name: '拉祜族' },
                                            { value: '水族', name: '水族' },
                                            { value: '东乡族', name: '东乡族' },
                                            { value: '纳西族', name: '纳西族' },
                                            { value: '景颇族', name: '景颇族' },
                                            { value: '柯尔克孜族', name: '柯尔克孜族' },
                                            { value: '土族', name: '土族' },
                                            { value: '达斡尔族', name: '达斡尔族' },
                                            { value: '仫佬族', name: '仫佬族' },
                                            { value: '羌族', name: '羌族' },
                                            { value: '布朗族', name: '布朗族' },
                                            { value: '撒拉族', name: '撒拉族' },
                                            { value: '毛南族', name: '毛南族' },
                                            { value: '仡佬族', name: '仡佬族' },
                                            { value: '锡伯族', name: '锡伯族' },
                                            { value: '阿昌族', name: '阿昌族' },
                                            { value: '普米族', name: '普米族' },
                                            { value: '朝鲜族', name: '朝鲜族' },
                                            { value: '塔吉克族', name: '塔吉克族' },
                                            { value: '怒族', name: '怒族' },
                                            { value: '乌孜别克族', name: '乌孜别克族' },
                                            { value: '俄罗斯族', name: '俄罗斯族' },
                                            { value: '鄂温克族', name: '鄂温克族' },
                                            { value: '德昂族', name: '德昂族' },
                                            { value: '保安族', name: '保安族' },
                                            { value: '裕固族', name: '裕固族' },
                                            { value: '赫哲族', name: '赫哲族' },
                                            { value: '京族', name: '京族' },
                                            { value: '塔塔尔族', name: '塔塔尔族' },
                                            { value: '独龙族', name: '独龙族' },
                                            { value: '鄂伦春族', name: '鄂伦春族' },
                                            { value: '门巴族', name: '门巴族' },
                                            { value: '珞巴族', name: '珞巴族' },
                                            { value: '基诺族', name: '基诺族' },
                                            { value: '其他', name: '其他' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: true,
                                        filterable: false,
                                        allowCreate: false
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_手机号码" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'mobilePhone'" class="field">手机号码</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="mobilePhone"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入手机号码',
                                        errorMessage: null,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '手机号码',
                                        propName: 'mobilePhone',
                                        propType: 'String',
                                        'textFormatter':'phone',
                                        valueMaxLength: 100,
                                        valueMinLength: null,
                                        iconName: 'sjhm',
                                        model: 'vo.mobilePhone',
                                        option: [],
                                        formTdAlign: 'text-left',
                                        formTdColspan: 8,
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_电子邮箱" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'email'" class="field">电子邮箱</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item ref="email" :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '', errorMessage: null, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '电子邮箱', propName: 'email', propType: 'String', textFormatter: 'email', valueMaxLength: 100, valueMinLength: null, tbFieldName: 'email', iconName: 'dzyj', model: 'vo.email', option: [], formTdAlign: 'text-left' }" :vo="vo" :can-edit="canEdit" />
                            </td>
                        </tr>
                        <tr>
                            <td ref="tdlbl_毕业学校" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'graduatedSchool'" class="field">毕业学校</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="graduatedSchool"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入最高学历毕业学校',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '毕业学校',
                                        propName: 'graduatedSchool',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        model: 'vo.graduatedSchool',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_最高学历" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'educational'" class="field">最高学历</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="educational"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '1：专科及本科以下\n2：本科\n3：研究生\n4：博士',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '',
                                        errorMessage: null,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '最高学历',
                                        propName: 'educational',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        tbFieldName: 'educational',
                                        iconName: 'xialakuang',
                                        model: 'vo.educational',
                                        option: [
                                            { value: '1', name: '专科及本科以下' },
                                            { name: '本科', value: '2' },
                                            { name: '研究生', value: '3' },
                                            { name: '博士', value: '4' }
                                        ],
                                        formTdAlign: 'text-left',
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_任教时间" class="el-table__cell tdlbl tdw13" colspan="1">
                                <!-- <span class="required">*</span> -->
                                <span v-field-lbl="'entryDate'" class="field">任教时间</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="entryDate"
                                    :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: '', elementReadonly: 1, elementType: 'date', emptyMessage: '', errorMessage: null, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '任教时间', propName: 'entryDate', propType: 'java.util.Date', textFormatter: 'yyyy-MM-dd', valueMaxLength: null, valueMinLength: null, tbFieldName: 'entrydate', iconName: 'sjxzk', model: 'vo.entryDate', option: [], formTdAlign: 'text-left', formTdColspan: 8, weekday: 0 }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td ref="tdlbl_毕业专业" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'graduationMajorName'" class="field">毕业专业</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="graduationMajorName"
                                    :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入毕业专业', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '毕业专业', propName: 'graduationMajorName', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.graduationMajorName', option: [] }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_是否有学位" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'hasDegree'" class="field">是否有学位</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <template v-if="canEdit">
                                    <form-item
                                        ref="hasDegree"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '是：是\n否：否',
                                            elementReadonly: 1,
                                            elementType: 'radio',
                                            emptyMessage: '请选择是否有学位',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '是否有学位',
                                            propName: 'hasDegree',
                                            propType: 'String',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.hasDegree',
                                            option: [
                                                { value: '是', name: '是' },
                                                { value: '否', name: '否' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: false,
                                            filterable: false,
                                            allowCreate: false
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </template>
                                <template v-else>{{ vo.hasDegree }}</template>
                            </td>
                            <td ref="tdlbl_学位" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'degree'" class="field">学位</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="degree"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '博士：博士\n硕士：硕士\n学士：学士\n无：无',
                                        elementReadonly: 0,
                                        elementType: 'select',
                                        emptyMessage: '请输入学位',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 24,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '学位',
                                        propName: 'degree',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.degree',
                                        option: [
                                            { value: '博士', name: '博士' },
                                            { value: '硕士', name: '硕士' },
                                            { value: '学士', name: '学士' },
                                            { value: '无', name: '无' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td ref="tdlbl_职业资格等级" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'level'" class="field">职业技能等级</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="level"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '一级/高级技师：一级/高级技师\n二级/技师：二级/技师\n三级/高级：三级/高级\n四级/中级：四级/中级\n五级/初级：五级/初级\n无：无',
                                        elementReadonly: 1,
                                        elementType: 'select',
                                        emptyMessage: '请输入职业资格等级',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 8,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '职业资格等级',
                                        propName: 'level',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 200,
                                        valueMinLength: null,
                                        model: 'vo.level',
                                        option: [
                                            { value: '一级/高级技师', name: '一级/高级技师' },
                                            { value: '二级/技师', name: '二级/技师' },
                                            { value: '三级/高级', name: '三级/高级' },
                                            { value: '四级/中级', name: '四级/中级' },
                                            { value: '五级/初级', name: '五级/初级' },
                                            { value: '无', name: '无' }
                                        ]
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_职业技能等级证书名称" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'certificatesName'" class="field">职业技能等级证书名称</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="certificatesName"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入职业技能等级证书名称',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 8,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '职业技能等级证书名称',
                                        propName: 'certificatesName',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        model: 'vo.certificatesName',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_专兼职" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'fullJob'" class="field">专兼职</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="fullJob"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '0：在编\n1：编外合同制\n2：劳务第三方\n3：外聘',
                                        elementReadonly: 1,
                                        elementType: 'radio',
                                        emptyMessage: '请输入专兼职',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 12,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '专兼职',
                                        propName: 'fullJob',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: 4,
                                        valueMinLength: null,
                                        model: 'vo.fullJob',
                                        option: [
                                            { value: '0', name: '在编' },
                                            { value: '1', name: '编外合同制' },
                                            { value: '2', name: '劳务第三方' },
                                            { value: '3', name: '外聘' }
                                        ],
                                        optionGenerateType: 0,
                                        clearable: false,
                                        filterable: false,
                                        allowCreate: false
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td ref="tdlbl_职位" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'post'" class="field">职位</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="post"
                                    :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入职位', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 12, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '职位', propName: 'post', propType: 'String', textFormatter: 'textfield', valueMaxLength: 50, valueMinLength: null, model: 'vo.post', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_岗位名称" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'gw'" class="field">岗位名称</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="gw"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '专业技术人员：专业技术人员\r\n普通工人：普通工人\r\n技术工人：技术工人\r\n管理人员：管理人员\r\n新参加工作未定岗：新参加工作未定岗\r\n',
                                        elementReadonly: 0,
                                        elementType: 'select',
                                        emptyMessage: '请输入岗位名称',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 12,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '岗位名称',
                                        propName: 'gw',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.gw',
                                        option: []
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_岗位待遇" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'gwSalary'" class="field">岗位待遇</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="gwSalary"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter:'专业技术十三级：专业技术十三级\n专业技术十二级：专业技术十二级\n专业技术十一级：专业技术十一级\n专业技术十级：专业技术十级\n专业技术九级：专业技术九级\n专业技术八级：专业技术八级\n专业技术七级：专业技术七级\n专业技术六级：专业技术六级\n专业技术五级：专业技术五级\n专业技术四级：专业技术四级\n专业技术三级：专业技术三级\n专业技术二级：专业技术二级\n专业技术一级：专业技术一级\n普通工人：普通工人\n技术工五级岗位（初级工）：技术工五级岗位（初级工）\n技术工四级岗位（中级工）：技术工四级岗位（中级工）\n技术工三级岗位（高级工）：技术工三级岗位（高级工）\n技术工二级岗位（技师）：技术工二级岗位（技师）\n技术工一级岗位（高级技师）：技术工一级岗位（高级技师）\n九级职员岗位（科员级）：九级职员岗位（科员级）\n新参加工作未定级：新参加工作未定级',
                                        elementReadonly: 0,
                                        elementType: 'select',
                                        emptyMessage: '请输入岗位待遇',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 12,
                                        isRequired: 0,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '岗位待遇',
                                        propName: 'gwSalary',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.gwSalary',
                                        option: []
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td ref="tdlbl_紧急联系人关系" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'linkmanRelation'" class="field">紧急联系人关系</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="linkmanRelation"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: null,
                                        elementReadonly: 0,
                                        elementType: 'input',
                                        emptyMessage: '请输入紧急联系人关系',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 0,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '紧急联系人关系',
                                        propName: 'linkmanRelation',
                                        propType: 'String',
                                        textFormatter: 'textfield',
                                        valueMaxLength: 50,
                                        valueMinLength: null,
                                        model: 'vo.linkmanRelation',
                                        option: [],
                                        autocomplete: 'off',
                                        dialog: 0,
                                        showWordLimit: false
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_紧急联系人" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'linkman'" class="field">紧急联系人</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="linkman"
                                    :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入紧急联系人', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '紧急联系人', propName: 'linkman', propType: 'String', textFormatter: 'textfield', valueMaxLength: 50, valueMinLength: null, model: 'vo.linkman', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_紧急联系人电话" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'linkmanTel'" class="field">紧急联系人电话</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="linkmanTel"
                                    :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入紧急联系人电话', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '紧急联系人电话', propName: 'linkmanTel', propType: 'String', textFormatter: 'phone', valueMaxLength: 20, valueMinLength: null, model: 'vo.linkmanTel', option: [], autocomplete: 'off', dialog: 0, showWordLimit: false }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td ref="tdlbl_家庭住址" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'homeAddress'" class="field">家庭住址</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item ref="homeAddress" :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入家庭住址', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '家庭住址', propName: 'homeAddress', propType: 'String', textFormatter: 'textfield', valueMaxLength: 255, valueMinLength: null, model: 'vo.homeAddress', option: [] }" :vo="vo" :can-edit="canEdit" />
                            </td>
                            <td ref="tdlbl_家庭电话" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'homeTel'" class="field">家庭电话</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item ref="homeTel" :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入家庭电话', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '家庭电话', propName: 'homeTel', propType: 'String', textFormatter: 'textfield', valueMaxLength: 20, valueMinLength: null, model: 'vo.homeTel', option: [] }" :vo="vo" :can-edit="canEdit" />
                            </td>
                            <td ref="tdlbl_身份" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'identity'" class="field">身份</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="identity"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '工人：工人\n干部：干部',
                                        elementReadonly: 1,
                                        elementType: 'radio',
                                        emptyMessage: '请选择身份',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 12,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '身份',
                                        propName: 'identity',
                                        propType: 'String',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.identity',
                                        option: [
                                            { value: '工人', name: '工人' },
                                            { value: '干部', name: '干部' },
                                            { value: '无', name: '无' },
                                        ]
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td ref="tdlbl_参加工作时间" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'joinWorkData'" class="field">参加工作时间</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="joinWorkData"
                                    :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: '', elementReadonly: 1, elementType: 'date', emptyMessage: '', errorMessage: null, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '参加工作时间', propName: 'joinWorkData', propType: 'java.util.Date', textFormatter: 'yyyy-MM-dd', valueMaxLength: null, valueMinLength: null, tbFieldName: 'joinworkdata', iconName: 'rqxzk', model: 'vo.joinWorkData', option: [], formTdAlign: 'text-left', weekday: 0 }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_进入单位时间 " class="el-table__cell tdlbl tdw13" colspan="1">
                                <span v-field-lbl="'enterDate'" class="field">进入单位时间</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="enterDate"
                                    :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: 'format：yyyy-MM-dd\r\n', elementReadonly: 1, elementType: 'date', emptyMessage: '请输入进入单位时间 ', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 12, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '进入单位时间 ', propName: 'enterDate', propType: 'java.util.Date', textFormatter: 'yyyy-MM-dd\r\n', valueMaxLength: null, valueMinLength: null, model: 'vo.enterDate', option: [] }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                            <td ref="tdlbl_人员状态" class="el-table__cell tdlbl tdw13" colspan="1">
                                <span class="required">*</span>
                                <span v-field-lbl="'personStatus'" class="field">人员状态</span>
                            </td>
                            <td class="el-table__cell tdcont tdw20" colspan="1">
                                <form-item
                                    ref="personStatus"
                                    :field="{
                                        defaultValue: null,
                                        elementCanEdit: '{${canEdit}}',
                                        elementCssHeight: null,
                                        elementCssWidth: null,
                                        elementFormatter: '1：实习\n2：试用\n3：正式\n4：退休\n5：离职',
                                        elementReadonly: 0,
                                        elementType: 'select',
                                        emptyMessage: '请选择人员状态',
                                        errorMessage: null,
                                        formTdAlign: 'text-left',
                                        formTdColspan: 8,
                                        isRequired: 1,
                                        onClickEvent: null,
                                        passenger: {},
                                        propComment: '人员状态',
                                        propName: 'personStatus',
                                        propType: 'Short',
                                        textFormatter: null,
                                        valueMaxLength: null,
                                        valueMinLength: null,
                                        model: 'vo.personStatus',
                                        option: [
                                            { value: '1', name: '实习' },
                                            { value: '2', name: '试用' },
                                            { value: '3', name: '正式' },
                                            { value: '4', name: '退休' },
                                            { value: '5', name: '离职' }
                                        ]
                                    }"
                                    :vo="vo"
                                    :can-edit="canEdit"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </el-form>
</template>

<script>
export default {
    props: {
        // vo: {
        //     type: Object,
        //     default: function() {
        //         return {}
        //     }
        // },
        canEdit: {
            type: Number,
            default: 1
        },
        moduleInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data: function () {
        return {
            vo: {},
            loginUser: this.$store.getters.loginUser,
            qxTypeVal: '',
            yxqxList: [],
            zyqxList: [],
            bjqxList: [],
            yxqxName: '',
            zyqxName: '',
            bjqxName: '',
            majorCategoryName: '',
            majorSubclassName: '',
            viewFile: false,
            fileList: [],
            imageSrc: '',
            type: '',
            oldMajor: null,
            oldMajorSub: null,
            isCanEdit: 0,
            show: true,
            originQxType: '',
            oldInfo: {}
        }
    },
    computed: {},
    watch: {
        canEdit: {
            handler(val) {
                this.isCanEdit = val
                console.log('handlercanEdit===========', val)
                if (val == 0) {
                    this.qxTypeVal = this.originQxType
                    this.oldMajor = this.oldInfo.majorCategoryId
                    this.oldMajorSub = this.oldInfo.majorSubclassId
                    this.yxqxName = this.oldInfo.yxqxName
                    this.zyqxName = this.oldInfo.zyqxName
                    this.bjqxName = this.oldInfo.bjqxName
                } else if (val == 1) {
                    this.show = false
                    setTimeout(() => {
                        this.show = true
                    }, 0)
                }
                this.$forceUpdate()
            }
        },
        'vo.idCardNumber': {
            handler(val, oval) {
                if (val) {
                    let value = this.parseIDCard(val)
                    if (value.code === 'success') {
                        let result = this.parseIDCard(val)
                        if (result.code === 'success') {
                            this.vo.sex = result.value.gender || this.vo.sex
                            this.vo.birthday = result.value.birthDate || this.vo.birthday
                            this.vo.age = result.value.age || this.vo.age
                        }
                    }
                }
            }
        }
    },
    created: function () {
        this.$http({
            method: 'post',
            url: '/xsgl/rsglArchiveInfo/listdata?urlsearch=userId:' + this.loginUser.userId
        }).then((res) => {
            if (res.code == 'success') {
                let _id = res.body.pageInfo.list[0].id
                this.$http({
                    method: 'get',
                    url: '/xsgl/rsglArchiveInfo/getById?id=' + _id
                }).then((res) => {
                    if (res.code == 'success') {
                        this.vo = res.body.vo
                        this.oldInfo = res.body.vo
                        this.imageSrc = `${location.origin}${process.env.VUE_APP_BASE_API}/xsgl/rsglArchiveInfo/download?dataField=idPhoto&nameField=idPhotoName&id=${this.vo.id}&httpPort=${location.port}`
                        if (this.vo.idPhotoName) this.viewFile = true
                        this.getMajorCategoryName()
                        console.log('this.vo', this.vo)
                        this.oldMajor = this.vo.majorCategoryId
                        this.oldMajorSub = this.vo.majorSubclassId
                        if (this.vo.yxqx && this.vo.yxqx.length > 0) {
                            this.vo.qxTypeVal = 'yx'
                            this.qxTypeVal = 'yx'
                            this.originQxType = 'yx'
                            this.$set(this.vo, 'qxTypeVal', 'yx')
                        } else if (this.vo.zyqx && this.vo.zyqx.length > 0) {
                            this.vo.qxTypeVal = 'zy'
                            this.qxTypeVal = 'zy'
                            this.originQxType = 'zy'
                            this.$set(this.vo, 'qxTypeVal', 'zy')
                        } else if (this.vo.bjqx && this.vo.bjqx.length > 0) {
                            this.vo.qxTypeVal = 'bj'
                            this.qxTypeVal = 'bj'
                            this.originQxType = 'bj'
                            this.$set(this.vo, 'qxTypeVal', 'bj')
                        }
                    }
                })
            }
        })
        //this.getMajorCategoryName()
    },
    beforeDestroy: function () {},
    activated() {
        //this.getMajorCategoryName()
    },
    mounted: function () {
        // if (this.vo.idPhotoName) this.viewFile = true
        // this.imageSrc =
        //     `${location.origin}${process.env.VUE_APP_BASE_API}/xsgl/rsglArchiveInfo/download?dataField=idPhoto&nameField=idPhotoName&id=${this.vo.id}&httpPort=${location.port}`
        // //this.getMajorCategoryName()
        // console.log('this.vo', this.vo)
        // this.oldMajor = this.vo.majorCategoryId;
        // this.oldMajorSub = this.vo.majorSubclassId;
        // if (this.vo.yxqx && this.vo.yxqx.length>0) {
        //     this.vo.qxTypeVal = 'yx'
        //     //this.qxTypeVal = 'yx'
        //     this.$set(this.vo, 'qxTypeVal', 'yx')
        // } else if (this.vo.zyqx && this.vo.zyqx.length>0) {
        //     this.vo.qxTypeVal = 'zy'
        //     //this.qxTypeVal = 'zy'
        //     this.$set(this.vo, 'qxTypeVal', 'zy')
        // } else if (this.vo.bjqx && this.vo.bjqx.length>0) {
        //     this.vo.qxTypeVal = 'bj'
        //     //this.qxTypeVal = 'bj'
        //     this.$set(this.vo, 'qxTypeVal', 'bj')
        // }
    },
    methods: {
        handleUploadChange(filed, fileList) {
            if (filed.name.indexOf('.jpg') === -1 && filed.name.indexOf('.png') === -1 && filed.name.indexOf('.JPG') === -1 && filed.name.indexOf('.PNG') === -1) {
                this.$alert('上传文件格式错误', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                })
                return
            }
            filed.id = this.vo.id
            this.$set(this.vo, 'idPhoto', filed.name)
            this.vo.idPhoto = filed.name
            this.fileList = fileList
            this.$set(this.vo, 'fileList', fileList)
        },
        upLoadImage() {
            this.$app
                .upload('/xsgl/rsglArchiveInfo/upload', this.fileList[0].raw, {
                    id: this.fileList[0].id,
                    nameField: 'idPhotoName',
                    dataField: 'idPhoto'
                })
                .then((res) => {
                    if (res.code == 'success') {
                        this.$message({
                            type: 'success',
                            message: '保存成功！'
                        })
                    } else {
                        this.$message.error('文件保存失败！')
                    }
                })
        },
        onBasicFormBeforeOpen: function ($scope, vo, defer) {
            console.log('archiveInfo form before open')
            if (this.vo.yxqx && this.vo.yxqx != '') {
                this.vo.qxTypeVal = 'yx'
                //this.qxTypeVal = 'yx'
                this.$set(this.vo, 'qxTypeVal', 'yx')
            } else if (vo.zyqx && vo.zyqx != '') {
                this.vo.qxTypeVal = 'zy'
                this.$set(this.vo, 'qxTypeVal', 'zy')
            } else if (vo.bjqx && vo.bjqx != '') {
                this.vo.qxTypeVal = 'bj'
                this.$set(this.vo, 'qxTypeVal', 'bj')
            }
            defer.resolve(true)
        },
        onBasicFormOpened: function ($scope, vo) {
            console.log('archiveInfo form opened')
            this.oldMajor = vo.majorCategoryId
            this.oldMajorSub = vo.majorSubclassId
        },
        onBasicFormBeforeSubmit: function ($scope, vo, defer) {
            console.log('basicInfo form submit validation success')
            vo.yxqx = ''
            vo.zyqx = ''
            vo.bjqx = ''
            console.log('this.qxTypeVal', vo, this.qxTypeVal)
            if (this.qxTypeVal == 'yx') {
                vo.yxqx = vo.yxqxList
            } else if (this.qxTypeVal == 'zy') {
                vo.zyqx = vo.zyqxList
            } else if (this.qxTypeVal == 'bj') {
                vo.bjqx = vo.bjqxList
            }
            if (!vo.majorCategoryId) {
                this.$message({ type: 'warning', message: '请选择院系' })
                defer.reject(reason)
                return
            } else if (!vo.majorSubclassId) {
                this.$message({ type: 'warning', message: '请选择专业' })
                defer.reject(reason)
                return
            } else if (!vo.classId) {
                this.$message({ type: 'warning', message: '请选择班级' })
                defer.reject(reason)
                return
            } else {
                defer.resolve(true)
            }
        },
        onBasicFormSubmited: function ($scope, vo) {
            console.log('basicInfo form submit validation success')
            if (this.fileList.length > 0) {
                this.upLoadImage()
            }
        },
        onSelectStaffCompleted(selectedNodes, attr) {
            this.$set(this.vo, 'name', selectedNodes[0].name)
            this.$set(this.vo, 'account', selectedNodes[0].account)
            this.$set(this.vo, 'userId', selectedNodes[0].userId)
        },
        //选择输入框的监听
        onSelectListpageRowCompleted(val, attr) {
            if (attr.name == 'majorCategoryName') {
                this.vo.majorCategoryName = val[0].majorName
                this.vo.majorCategoryId = val[0].id
                this.$set(this.vo, 'majorCategoryName', val[0].majorName)
                if (this.oldMajor) {
                    if (this.oldMajor != val[0].id) {
                        this.$set(this.vo, 'majorSubclassId', null)
                        this.$set(this.vo, 'majorSubclassName', null)
                        this.$set(this.vo, 'classId', null)
                        this.$set(this.vo, 'className', null)
                        this.$set(this.vo, 'classCode', null)
                    }
                } else {
                    this.oldMajor = val[0].id
                }
            } else if (attr.name == 'majorSubclassName') {
                this.vo.majorSubclassName = val[0].majorName
                this.vo.majorSubclassId = val[0].id
                this.$set(this.vo, 'majorSubclassName', val[0].majorName)
                if (this.oldMajorSub) {
                    if (this.oldMajorSub != val[0].id) {
                        this.$set(this.vo, 'classId', null)
                        this.$set(this.vo, 'className', null)
                        this.$set(this.vo, 'classCode', null)
                    }
                } else {
                    this.oldMajorSub = val[0].id
                }
            } else if (attr.name == 'className') {
                this.vo.className = val[0].className
                this.vo.classId = val[0].classId
                this.vo.classCode = val[0].classCode
                this.$set(this.vo, 'className', val[0].className)
            } else if (attr.name == 'yxqx') {
                let _list = []
                let _list2 = []
                val.forEach((v) => {
                    _list.push(v.majorName)
                    _list2.push(v.id)
                })
                this.yxqxName = _list.join(',')
                this.yxqxList = val
                this.$set(this.vo, 'yxqxList', _list2.join(','))
            } else if (attr.name == 'zyqx') {
                let _list = []
                let _list2 = []
                val.forEach((v) => {
                    _list.push(v.majorName)
                    _list2.push(v.id)
                })
                this.zyqxList = val
                this.zyqxName = _list.join(',')
                this.$set(this.vo, 'zyqxList', _list2.join(','))
            } else if (attr.name == 'bjqx') {
                let _list = []
                let _list2 = []
                val.forEach((v) => {
                    _list.push(v.className)
                    _list2.push(v.id)
                })
                this.bjqxList = val
                this.bjqxName = _list.join(',')
                this.$set(this.vo, 'bjqxList', _list2.join(','))
            }
        },
        //获取权限显示
        getMajorCategoryName() {
            console.log('this.vo', this.vo)
            // console.log('this.vo.yxqx',this.vo.yxqx)
            // console.log('this.vo.yxqx.length',this.vo.yxqx.length)
            // console.log('this.vo.zyqx.length',this.vo.zyqx.length)
            //if(vo.majorCategoryId){
            if (this.vo.yxqx && this.vo.yxqx.length > 0) {
                this.qxTypeVal = 'yx'
                let _yxqx = this.vo.yxqx.split(',')
                console.log('_yxqx', _yxqx)
                this.$http({
                    method: 'post',
                    url: '/xsgl/schoolMajors/listdata'
                }).then((res) => {
                    let _list = res.body.pageInfo.list
                    let _nameList = []
                    _list.forEach((v) => {
                        if (_yxqx.indexOf(v.id) >= 0) {
                            _nameList.push(v.majorName)
                        }
                    })
                    this.yxqxName = _nameList.join(',')
                    this.oldInfo.yxqxName = this.yxqxName
                })
            } else if (this.vo.zyqx && this.vo.zyqx.length > 0) {
                this.qxTypeVal = 'zy'
                let _zyqx = this.vo.zyqx.split(',')
                console.log('_zyqx', _zyqx)
                this.$http({
                    method: 'post',
                    url: '/xsgl/schoolMajors/listdata'
                }).then((res) => {
                    let _list = res.body.pageInfo.list
                    let _nameList = []
                    _list.forEach((v) => {
                        if (_zyqx.indexOf(v.id) >= 0) {
                            _nameList.push(v.majorName)
                        }
                    })
                    this.zyqxName = _nameList.join(',')
                    this.oldInfo.zyqxName = this.zyqxName
                })
            } else if (this.vo.bjqx && this.vo.bjqx.length > 0) {
                this.qxTypeVal = 'bj'
                let _bjqx = this.vo.bjqx.split(',')
                console.log('_bjqx', _bjqx)
                this.$http({
                    method: 'post',
                    url: '/xsgl/schoolClazz/listdata'
                }).then((res) => {
                    let _list = res.body.pageInfo.list
                    let _nameList = []
                    _list.forEach((v) => {
                        console.log('_bjqx.indexOf(v.id)', _bjqx.indexOf(v.id))
                        if (_bjqx.indexOf(v.id) >= 0) {
                            _nameList.push(v.className)
                        }
                    })
                    this.bjqxName = _nameList.join(',')
                    this.oldInfo.bjqxName = this.bjqxName
                })
            }
            // }
        },
        //选择院系、专业、班级
        selectType(type) {
            this.type = type
            console.log(this.oldMajor, this.oldMajorSub)
        },
        //选择 专业,班级 的搜索条件
        onDialogListDataBeforeLoad($scope, qparams) {
            console.log('onDialogListDataBeforeLoad', $scope)
            qparams.urlsearch = ''
            if (this.type == 'className') {
                if (this.vo.majorSubclassId) {
                    qparams.urlsearch = 'schoolMajorsId:' + this.vo.majorSubclassId
                } else {
                    this.$message({ type: 'warning', message: '请先选择专业！' })
                    return
                }
            } else if (this.type == 'sub') {
                if (this.vo.majorCategoryId) {
                    qparams.urlsearch = 'parentId:' + this.vo.majorCategoryId
                } else {
                    this.$message({ type: 'warning', message: '请先选择院系！' })
                    return
                }
            }
        },
        parseIDCard(idCard) {
            // 统一转为大写并去除空格
            idCard = idCard.toUpperCase().trim()

            // 基础校验
            if (!/^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(idCard)) {
                // throw new Error('身份证格式不正确');
                return { code: 'error' }
            }

            // 提取信息
            const birthDateStr = idCard.slice(6, 14)
            const genderCode = parseInt(idCard.charAt(16), 10) // 第17位（索引16）

            // 解析出生日期
            const year = parseInt(birthDateStr.slice(0, 4), 10)
            const month = parseInt(birthDateStr.slice(4, 6), 10) - 1 // 月份从0开始
            const day = parseInt(birthDateStr.slice(6, 8), 10)
            const birthDate = new Date(year, month, day)

            // 计算年龄
            const today = new Date()
            let age = today.getFullYear() - birthDate.getFullYear()
            if (today.getMonth() < birthDate.getMonth() || (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
                age--
            }

            // 获取性别
            const gender = genderCode % 2 === 0 ? '0' : '1'

            return {
                code: 'success',
                value: {
                    birthDate: `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
                    age: age,
                    gender: gender
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
/deep/ .el-radio__original {
    display: none !important;
}

/deep/.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
}
</style>
